import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import debounce from '../../helpers/debounce.js';

var RemoteSearch = /*#__PURE__*/function () {
  function RemoteSearch(autocomplete) {
    _classCallCheck(this, RemoteSearch);

    this.cachedOptions = '';
    this.autocomplete = autocomplete;
    this.makeRequest = debounce(this.makeRequest.bind(this), 300);
  }

  _createClass(RemoteSearch, [{
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.autocomplete.setAttribute('loading', '');
                this.autocomplete.removeAttribute('error');
                _context.next = 4;
                return this.makeRequest(value);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function search(_x) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "start",
    value: function start() {
      if (this.cachedOptions) {
        this.insertOptions(this.cachedOptions, {
          cached: true
        });
      } else {
        this.search('');
      }
    }
  }, {
    key: "stop",
    value: function stop() {//
    }
  }, {
    key: "makeRequest",
    value: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
        var _a, _this$abortController, signal, url, params, response, options;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.emit('loadstart');
                (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort();
                _this$abortController = this.abortController = new AbortController(), signal = _this$abortController.signal;
                url = new URL(this.autocomplete.src, window.location.href);
                params = new URLSearchParams(url.search.slice(1));
                params.append(this.autocomplete.param, value);
                url.search = params.toString();
                _context2.prev = 7;
                _context2.next = 10;
                return fetch(url.toString(), {
                  signal: signal,
                  credentials: 'same-origin',
                  headers: {
                    accept: 'text/fragment+html'
                  }
                });

              case 10:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 14;
                return response.text();

              case 14:
                options = _context2.sent;

                if (value === '') {
                  this.cachedOptions = options;
                }

                _context2.next = 18;
                return this.insertOptions(options);

              case 18:
                this.abortController = undefined;
                this.emit('load');
                this.autocomplete.removeAttribute('loading');
                this.emit('loadend');
                _context2.next = 29;
                break;

              case 24:
                _context2.t0 = Error;
                _context2.next = 27;
                return response.text();

              case 27:
                _context2.t1 = _context2.sent;
                throw new _context2.t0(_context2.t1);

              case 29:
                _context2.next = 40;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t2 = _context2["catch"](7);

                if (!(_context2.t2 instanceof Error && _context2.t2.name === 'AbortError')) {
                  _context2.next = 35;
                  break;
                }

                return _context2.abrupt("return");

              case 35:
                this.abortController = undefined;
                this.autocomplete.setAttribute('error', '');
                this.emit('error');
                this.autocomplete.removeAttribute('loading');
                this.emit('loadend');

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 31]]);
      }));

      function makeRequest(_x2) {
        return _makeRequest.apply(this, arguments);
      }

      return makeRequest;
    }()
  }, {
    key: "insertOptions",
    value: function () {
      var _insertOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        var _ref,
            _ref$cached,
            cached,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, _ref$cached = _ref.cached, cached = _ref$cached === void 0 ? false : _ref$cached;
                this.autocomplete.optionsContainer.innerHTML = options;
                this.autocomplete.checkIfListIsEmpty();

                if (!cached) {
                  this.autocomplete.combobox.initializeOptions();
                } // Start the select variant to select the option(s).


                this.autocomplete.selectVariant.start(); // Update the floating UI position after the listbox content has been updated.

                _context3.next = 7;
                return this.autocomplete.reposition();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function insertOptions(_x3) {
        return _insertOptions.apply(this, arguments);
      }

      return insertOptions;
    }()
  }, {
    key: "emit",
    value: function emit(name) {
      this.autocomplete.emit(name, {
        bubbles: false,
        prefix: false
      });
    }
  }]);

  return RemoteSearch;
}();

export { RemoteSearch as default };